import { ClientWebEmbeddingMessageType } from '@youhelp-ru/common/clientWebEmbedding';
import { authenticationTokenSelector } from '@cp/shared/api/core';
import React from 'react';
import { useSelector } from 'react-redux';
import { IEmbeddingMessagesTriggerProps } from '../types';

export const useAuthMessageTriggers = ({ isRecipientReady, postMessage }: IEmbeddingMessagesTriggerProps) => {
  const authToken = useSelector(authenticationTokenSelector);

  React.useEffect(() => {
    if (!isRecipientReady) {
      return;
    }

    if (authToken) {
      postMessage({ type: ClientWebEmbeddingMessageType.ClientIsLoggedIn, token: authToken });
    } else {
      postMessage({ type: ClientWebEmbeddingMessageType.ClientIsLoggedOut });
    }
  }, [authToken, isRecipientReady, postMessage]);
};
